/**
 * Process odds to mach FullBetSlip format
 * @param {Dictionary<string>} displayOdds Initial odds
 * @return {string} Formatted odds
 */
export const getBetSlipOdds = (displayOdds) => (displayOdds && displayOdds.american)
    ? displayOdds.american.replace("−", "-")
    : "0";
//# sourceMappingURL=getBetSlipOdds.js.map